import React from 'react';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';
import { ResizableSideType, useResizablePrintAreaContext } from './resizablePrintAreaContext';
import ResizableSideItem from './resizableSideTypeItem';

const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 24px;
    margin-top: 24px;
    margin-bottom: 24px;

    @media (max-width: 1475px) {
        gap: 15px;
    }
`;

interface IResizableSideTypeSectionProps {}

const ResizableSideTypeSection = ({}: IResizableSideTypeSectionProps) => {
    const { sideType, setSideType } = useResizablePrintAreaContext();

    const handleOnClickSideItem = (type: ResizableSideType) => {
        setSideType(type);
    };

    return (
        <Container>
            <ResizableSideItem
                type='single'
                selected={sideType === 'single'}
                tooltip={<span>{T._('The product will have only one customizable side. Examples include a canvas, a sign, or a sticker.', 'Admin')}</span>}
                onClick={() => handleOnClickSideItem('single')}
            />
            <ResizableSideItem
                type='double-syn'
                selected={sideType === 'double-syn'}
                tooltip={
                    <span>
                        {T._(
                            'Product with two sides, the customer can customize both the front and the back, which will remain synchronized in size. Examples include a banner or advertising flag, a hang tag, or a business card.',
                            'Admin'
                        )}
                    </span>
                }
                onClick={() => handleOnClickSideItem('double-syn')}
            />
            {/* <ResizableSideItem type='double' selected={sideType === 'double'} onClick={() => handleOnClickSideItem('double')} /> */}
            <ResizableSideItem
                type='multiple'
                selected={sideType === 'multiple'}
                tooltip={
                    <span>
                        {T._(
                            'This option is for products like wallpapers for a room where there are multiple sides (e.g., four walls) with different dimensions. Each side is independent in terms of design and size.',
                            'Admin'
                        )}
                    </span>
                }
                onClick={() => handleOnClickSideItem('multiple')}
            />
            <ResizableSideItem
                type='multiplesyn'
                selected={sideType === 'multiplesyn'}
                tooltip={
                    <span>
                        {T._(
                            'This option is for creating products with more than two sides that always maintain the same size. The sides can have different designs but will always have the same size.',
                            'Admin'
                        )}
                        .
                    </span>
                }
                onClick={() => handleOnClickSideItem('multiplesyn')}
            />
        </Container>
    );
};

export default ResizableSideTypeSection;
